'use client'

import { useTranslations } from 'next-intl'
import { ReactNode } from 'react'

import ViverseButton from '@/components/ViverseButton'
import ViverseDialog from '@/components/ViverseDialog'

interface ConfirmDialogProps {
  onConfirm: () => void
  dialogTrigger?: ReactNode
  title: string
  content: string | ReactNode
  open: boolean
  onOpenChange: (open: boolean) => void
}

function ConfirmDialog({
  onConfirm,
  dialogTrigger,
  title,
  content,
  open,
  onOpenChange,
}: ConfirmDialogProps) {
  const t = useTranslations()

  const handleClose = () => {
    onOpenChange(false)
  }

  return (
    <ViverseDialog
      dialogTrigger={dialogTrigger}
      title={title}
      contentClassName="flex flex-col max-w-[420px] lg:min-w-[420px] min-w-0! p-10"
      titleClassName="border-b-0 p-0 h-auto 1.5xl:h-auto"
      withCloseButton={false}
      open={open}
      onClose={handleClose}
      onOpenChange={onOpenChange}
    >
      <div className="relative flex w-full flex-1 flex-col items-center">
        <div className="body-1 mb-8">{content}</div>
        <div className="flex w-full flex-col">
          <ViverseButton variant="colorful" onClick={onConfirm} size="xLarge">
            {t('confirm-dialog.btn.ok')}
          </ViverseButton>
          <ViverseButton
            className="mt-4 px-10"
            variant="outline"
            size="xLarge"
            onClick={handleClose}
          >
            {t('confirm-dialog.btn.cancel')}
          </ViverseButton>
        </div>
      </div>
    </ViverseDialog>
  )
}

export default ConfirmDialog
